// @module Dev.ShoppingActions.ShoppingActionsModule
define('ContactusHome.View'
,	[
		'contactushome.tpl'
	
	,	'Dev.ShoppingActions.ShoppingActionsModule.Model'
	
	,	'Backbone'
	,	'jQuery'
	,	'Utils'
    ]
, function (
		contactushome_tpl
	
	,	ShoppingActionsModuleModel
	
	,	Backbone
	,	JQuery
	,	Utils
)
{
    'use strict';

	return Backbone.View.extend({

		template: contactushome_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new ShoppingActionsModuleModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
      		this.environment=options.env_comp;
		}

	,	events: {
			//'click [data-action="ContactusHome"]': 'ContactusHome',
			'submit form': 'ContactusHome'
		}

	,	ContactusHome: function ContactusHome(e){
			var firstname = document.getElementById("firstname").value;
            var lastname = document.getElementById("lastname").value;
			var phone = document.getElementById("phone").value;
            var email = document.getElementById("email").value;
            var subject = document.getElementById("subject").value;
            var message = document.getElementById("message").value;

			var smsconsent = this.$('#smsconsent').is(":checked");
			var isSMSsend ;
			if(smsconsent== true){
				isSMSsend = "T";
					
			}else if(smsconsent==false){
				isSMSsend = "F";
			}

            var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (firstname.trim() == "" || lastname.trim() == "" || phone.trim() == "" || email.trim() == "" || subject.trim() == "" || message.trim() == "") {
                alert("All fields are required");
                return false;
            }

			// if(Utils.validatePhone(phone) === 'Phone Number is invalid' || Utils.validatePhone(phone) === 'Phone is required'){
			if(Utils.validatePhone(phone) === 'Phone Number is invalid' ){
				alert(Utils.validatePhone(phone))
				return false;
				
			}

            if (!emailRegex.test(email)) {
                alert("Please enter a valid email address");
                return false;
            }else{
            	e.preventDefault();
           		e.stopPropagation();
            	var model=new ShoppingActionsModuleModel();
            	model.set({firstname: firstname});
				model.set({lastname: lastname});
				model.set({email: email});
				model.set({phone: phone});
				model.set({subject: subject});
				model.set({message: message});
				model.set({smsconsent: isSMSsend});
				model.set({ContactusHome: true});
				model.save().done(function(result){
				console.log('result', result);
				$('#contactForm')[0].reset();
			});
            }
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return Dev.ShoppingActions.ShoppingActionsModule.View.Context
	,	getContext: function getContext()
		{
			return {
				
			}
		}
	});
});
